import * as React from 'react';

import LoggedOutDesktopHeader from 'bundles/page-header/components/optimized/LoggedOutDesktopHeader';
import PageHeaderParentWrapper from 'bundles/page-header/components/optimized/PageHeaderParentWrapper';
import type { PropsFromCaller } from 'bundles/page-header/components/optimized/PageHeaderParentWrapper';

const LoggedOutPageHeader = (props: PropsFromCaller) => {
  const pageHeaderProps = {
    ...props,
    DesktopHeader: LoggedOutDesktopHeader,
  };
  return <PageHeaderParentWrapper {...pageHeaderProps} />;
};

export default LoggedOutPageHeader;
